import { Row } from '@/components/grid/grid-component';
import RadioButtonGroup from '@/components/react-hook-form-inputs/radio-button/radio-button-component';
import { SubheaderText } from '@/utils/global-fonts';
import styled from 'styled-components';

const RowStyle = styled(Row)`
  padding: 24px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-height: 80vh;
  overflow-y: auto;
`;

const AddOptionButton = styled.div`
  display: flex;
  align-items: center;
  width: 40%;
  justify-content: flex-start;
  cursor: pointer;
  padding: 0 10px;

  svg {
    margin: 0 12px 0 0;
  }
`;

const RadioButton = styled(RadioButtonGroup)`
  margin: 0;
  width: unset;
  background-color: black;
`;

const OptionsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

const OptionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const DropdownHeading = styled(SubheaderText)`
  margin-bottom: 16px;
`;

const DeletePartNumbCol = styled.div`
  height: 48px;
  margin-left: 16px;

  svg {
    fill: ${(props) => props.theme.COLOR_GREY3};
    cursor: pointer;
  }
`;

const StyledForm = {
  RowStyle,
  AddOptionButton,
  DeletePartNumbCol,
  OptionsRow,
  RadioButton,
  OptionsDiv,
  DropdownHeading,
};

export default StyledForm;
